import { Grid, Box } from '@mui/material';
import VideoCard from '../../../../components/VideoCard/VideoCard';
import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import { useWidth } from '../../../../utils/hooks';
const HelpCenterHeader = forwardRef(({ bannerContents, bannerSideContents, intl, ...props }, ref) => {
  const bannerRef = useRef(null);
  const w = useWidth();
  const upperMD = w === 'lg' || w === 'xl' || w === 'md';

  useImperativeHandle(ref, () => {
    return {
      getBanner: () => bannerRef.current
    };
  });
  return (
    <Grid container spacing={4}>
      {bannerContents?.items && (
        <Grid size={{ xs: 12, md: 6, lg: 7 }}>
          <VideoCard
            ref={bannerRef}
            intl={intl}
            type="banner"
            itemData={bannerContents?.items[0]}
            key={`banner_${bannerContents?.items[0].id}`}
            {...props}
          />
        </Grid>
      )}
      <Grid size={{ xs: 12, md: 6, lg: 5 }}>
        {upperMD && <Box style={{ height: '42px', width: '100%' }} />}
        {bannerSideContents?.items && (
          <Grid container spacing={2}>
            {bannerSideContents?.items?.map((item, index) => (
              <Grid key={`banner_side_${item.id}`} style={{ width: '100%' }}>
                <VideoCard intl={intl} type="landscape" itemData={item} {...props} />
              </Grid>
            ))}
          </Grid>
        )}
      </Grid>
    </Grid>
  );
});

export default HelpCenterHeader;
